import React from 'react';
import { useHistory } from 'react-router-dom';
import { differenceInDays } from 'date-fns';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { Card, CardActionArea } from '@material-ui/core';
import { Person as PersonIcon } from '@material-ui/icons';
import BoardItem from './BoardItem';
import { Task } from '../Task.interface';

export interface BoardItemProps {
  task: Task;
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  isLoading?: boolean;
  onSelectTask?: (task: Task) => void;
}

const BoardItemWithSubtask: React.FC<BoardItemProps> = (
  props: BoardItemProps
) => {
  const { task, provided, isLoading, onSelectTask } = props;
  return (
    <Card
      className='task-card-with-subtask'
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      onClick={() => onSelectTask?.(task)}
    >
      <div className='title'>{task.name}</div>
      {task.children?.map((subTask: any) => (
        <BoardItem
          subTask
          key={subTask.id}
          {...{ task: subTask, onSelectTask }}
        />
      ))}
    </Card>
  );
};

export default BoardItemWithSubtask;
